var $68ac2954d56e12b4$exports = {};
$68ac2954d56e12b4$exports = {
  "Empty": "Vazio"
};
export { $68ac2954d56e12b4$exports as default };